// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MaterialContainer_wrapper__NSYSy"};